{
  "more": "Vairāk vienumu"
}
